import { RouteObject } from "react-router";
import NumbersDocumentBaseDataRoute from "@/routes/base-data/numbers/document/numbers-document-base-data-route";
import { NumbersProcessBaseDataRoute } from "@/routes/base-data/numbers/process/numbers-process-base-data-route";

export const numbersBaseDataRoutes: RouteObject[] = [
  {
    path: "document",
    element: <NumbersDocumentBaseDataRoute />,
  },
  {
    path: "process",
    element: <NumbersProcessBaseDataRoute />,
  },
];
